export class GetDlsgPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dlsgPolicy",
            "baseName": "dlsgPolicy",
            "type": "DlsgPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDlsgPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
